// import { useState } from 'react'
import { useEffect, useState } from 'react'
import { ReactComponent as Add } from '../assets/icons/add.svg'
import { ReactComponent as UploadFile } from '../assets/icons/upload-file.svg'
import { ReactComponent as Warning } from '../assets/icons/warning.svg'
import { getCoursesStudent } from '../apis/course.ts'
import StudentAddModal from './StudentAddModal'
import { postDocumentsUploads } from '../apis/document.ts'
import FileProgressModal from './FileProgressModal.jsx'
import { OverWriteModal } from './Modal.jsx'

function ClassSessionNull({ onStateChange }) {
  return (
    <div className='flex h-full w-full flex-col items-center justify-center gap-40'>
      <div className='flex flex-col items-center gap-4'>
        <p className='text-center text-h1-medium text-label-info'>
          생성된 차시가 없습니다.
          <br />
          차시를 추가해주세요!
        </p>
      </div>
      <button
        onClick={() => onStateChange()}
        className='flex items-center justify-center gap-6 rounded-10 bg-mint-50 fill-inverse-label px-28 py-12'
      >
        <Add />
        <p className='text-body1-semibold text-inverse-label'>차시 추가</p>
      </button>
    </div>
  )
}

function ClassDataNull({ subjectId, getApi }) {
  const [isActive, setIsActive] = useState(false)
  const [errorMessage, setErrorMessage] = useState()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isOverWriteModalOpen, setIsOverWriteModalOpen] = useState(false)
  const [fileInfo, setFileInfo] = useState([])
  const [errorFileInfo, setErrorFileInfo] = useState([])
  const [currentModalIndex, setCurrentModalIndex] = useState(0)

  useEffect(() => {
    window.addEventListener('dragover', function (event) {
      event.preventDefault()
      event.stopPropagation()
    })

    window.addEventListener('drop', function (event) {
      event.preventDefault()
      event.stopPropagation()
    })
  }, [])

  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
    }, 5000)

    return () => clearTimeout(timer)
  }, [isVisible])

  /*************** 파일 업로드 API **************/
  const handleDrop = async (e) => {
    e.preventDefault()
    setIsActive(false)
    const fileList = e.dataTransfer.files
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i]
      postDocumentsUploadsApi(file, null, i)
    }
  }

  const handleFileUpload = (e) => {
    const fileList = e.target.files
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i]
      postDocumentsUploadsApi(file, null, i)
    }
  }

  const postDocumentsUploadsApi = async (file, action, i) => {
    setIsModalOpen(true)
    const fileInfoItem = {
      index: i,
      name: file.name,
      size: file.size,
      type: file.type,
      progress: 0,
      status: null,
    }
    setFileInfo((prev) => [...prev, fileInfoItem])

    const postDocumentsUploadsResponse = await postDocumentsUploads(
      { subjectId: subjectId, action: action },
      { files: file },
      (currentProgress) => {
        setFileInfo((prev) =>
          prev.map((item) =>
            item.index === fileInfoItem.index ? { ...item, progress: currentProgress } : item,
          ),
        )
      },
    )

    if (postDocumentsUploadsResponse.error) {
      if (postDocumentsUploadsResponse.error.code === 'E409') {
        setIsOverWriteModalOpen(true)
        setErrorFileInfo((prev) => [...prev, file])
        setFileInfo((prev) =>
          prev.map((item) =>
            item.index === fileInfoItem.index ? { ...item, status: 'error' } : item,
          ),
        )
      } else {
        setErrorMessage(postDocumentsUploadsResponse.error.message)
        setIsVisible(true)
        setFileInfo((prev) =>
          prev.map((item) =>
            item.index === fileInfoItem.index ? { ...item, status: 'error' } : item,
          ),
        )
      }
      return
    } else {
      console.log(postDocumentsUploadsResponse.result)
      setFileInfo((prev) =>
        prev.map((item) =>
          item.index === fileInfoItem.index ? { ...item, status: 'success' } : item,
        ),
      )
      await getApi()
      setErrorMessage()
    }
  }
  // console.log(uploadedInfo)
  return (
    <div
      onDragEnter={(e) => {
        e.preventDefault()
        setIsActive(true)
      }}
      onDragOver={(e) => {
        e.preventDefault()
        setIsActive(true)
      }}
      onDragLeave={() => {
        setIsActive(false)
      }}
      onDrop={handleDrop}
      // className='flex flex-col items-center justify-center w-full h-full gap-40 pt-80'
      className={`relative flex h-full w-full flex-col items-center justify-center gap-40 pt-80 ${isActive ? 'rounded-8 border border-border-active bg-background-secondary' : ''}`}
    >
      <div className='flex flex-col items-center gap-4'>
        <p className='text-center text-h1-medium text-label-info'>
          파일을 여기 끌어다 놓거나
          <br /> 자료 등록 버튼을 클릭해주세요!
        </p>
      </div>
      <label
        // className='button_solid_primary_lg '
        className={`${isActive ? 'button_solid_primary_disabled_lg fill-label-placeholder' : 'button_solid_primary_lg fill-inverse-label'} gap-6`}
      >
        <input
          className='hidden'
          type='file'
          onChange={handleFileUpload}
          accept='.jpg, .png, .pdf, .ppt'
        />
        <Add />
        <p>자료 등록</p>
      </label>
      {isModalOpen && (
        <FileProgressModal
          close={() => setIsModalOpen(false)}
          fileInfo={fileInfo}
          setFileInfo={setFileInfo}
        />
      )}
      {isActive && (
        <div className='absolute bottom-16 flex items-center gap-8 rounded-90 bg-border-active py-4 pl-4 pr-16 shadow-emphasize'>
          <UploadFile />
          <p className='text-body1-long-medium text-static-white'>
            이곳에 파일을 놓으면 업로드를 시작합니다
          </p>
        </div>
      )}
      {isVisible && errorMessage && (
        <div className='absolute bottom-16 flex items-center gap-8 rounded-90 border border-status-negative bg-red-99 fill-status-negative px-16 py-12 shadow-emphasize'>
          <Warning />
          <p className='text-body1-long-regular text-status-negative'>{errorMessage}</p>
        </div>
      )}
      {isOverWriteModalOpen && currentModalIndex < errorFileInfo.length && (
        <OverWriteModal
          key={currentModalIndex}
          close={() => {
            if (currentModalIndex + 1 < errorFileInfo.length) {
              setCurrentModalIndex(currentModalIndex + 1)
            } else {
              setIsOverWriteModalOpen(false)
            }
          }}
          fileInfo={errorFileInfo[currentModalIndex]}
          postApi={(file, action) => postDocumentsUploadsApi(file, action)}
          subjectId={subjectId}
          setFileInfo={setFileInfo}
        />
      )}
    </div>
  )
}

function ClassStudentNull({ courseId, semesterId }) {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)

  const [studentList, setStudentList] = useState()
  useEffect(() => {
    getCoursesStudentApi()
    // eslint-disable-next-line
  }, [])

  const getCoursesStudentApi = async () => {
    const getCoursesStudentResponse = await getCoursesStudent({
      courseId: courseId,
      // sortBy: getCategoryType(sortedBy),
      // name: search,
    })

    if (getCoursesStudentResponse.error) {
      console.log(getCoursesStudentResponse)
      return
    } else {
      setStudentList(getCoursesStudentResponse.data)
    }
  }
  return (
    <div className='flex h-full w-full flex-col items-center justify-center gap-40'>
      <div className='flex flex-col items-center gap-4'>
        <p className='text-center text-h1-medium text-label-info'>
          등록된 수강 학생이 없습니다 <br /> 학생을 추가해주세요!
        </p>
      </div>
      <button
        onClick={() => setIsAddModalOpen(true)}
        className='flex items-center justify-center gap-6 rounded-10 bg-mint-50 fill-inverse-label px-28 py-12'
      >
        <Add />
        <p className='text-body1-semibold text-inverse-label'>학생 직접 추가</p>
      </button>
      {isAddModalOpen && (
        <StudentAddModal
          close={() => setIsAddModalOpen(false)}
          courseId={courseId}
          getApi={() => getCoursesStudentApi()}
          semesterId={semesterId}
          existingStudent={studentList}
        />
      )}
    </div>
  )
}

export { ClassDataNull, ClassSessionNull, ClassStudentNull }
